import { SubmitButton } from "@xola/ui-kit";
import { FormikProps } from "formik";
import { isEqual } from "lodash";
import React, { useRef } from "react";
import { Permission, Seller } from "types";
import { useAuthorization } from "../../../hooks/useAuthorization";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { ContentLayout } from "../../Layout/ContentLayout";
import { LanguagePreferencesFormRef } from "./LanguagePreferences";
import { PurchasesPreferences } from "./PurchasePreferences";
import { RosterPreferences } from "./RosterPreferences";

export const Preferences = () => {
    const { isGranted } = useAuthorization();

    const languagePreferencesFormRef = useRef<LanguagePreferencesFormRef>(null);
    const purchasesPreferencesFormRef = useRef<FormikProps<Seller>>(null);
    const rosterPreferencesFormRef = useRef<FormikProps<Seller>>(null);

    const handleSubmit = () => {
        // Check for LanguagePreferences
        if (!isEqual(languagePreferencesFormRef.current?.initialValues, languagePreferencesFormRef.current?.values)) {
            languagePreferencesFormRef.current?.handleSubmit();
        }

        // Check for LanguagePreferences
        if (!isEqual(purchasesPreferencesFormRef.current?.initialValues, purchasesPreferencesFormRef.current?.values)) {
            purchasesPreferencesFormRef.current?.handleSubmit();
        }

        // Check for RosterPreferences
        if (!isEqual(rosterPreferencesFormRef.current?.initialValues, rosterPreferencesFormRef.current?.values)) {
            rosterPreferencesFormRef.current?.handleSubmit();
        }
    };

    const isSubmitting = [
        languagePreferencesFormRef.current?.isSubmitting,
        purchasesPreferencesFormRef.current?.isSubmitting,
        rosterPreferencesFormRef.current?.isSubmitting,
    ].some(Boolean);

    const handleReset = () => {
        // Reset all forms
        languagePreferencesFormRef.current?.handleReset();
        purchasesPreferencesFormRef.current?.handleReset();
        rosterPreferencesFormRef.current?.handleReset();
    };

    return (
        <ContentLayout isWide>
            <h2 className="mt-4">Preferences</h2>
            <div className="divide-y divide-gray-lighter">
                {/* TODO: The “Languages” section according to the ticket X2-7157 should be removed until multilingualism is supported in X2 */}

                {/* <ContentLayout.Section title="Languages">
                    <LanguagePreferences ref={languagePreferencesFormRef} />
                </ContentLayout.Section> */}

                {isGranted(Permission.PREFERENCES_PURCHASES_VIEW) && (
                    <ContentLayout.Section title="Purchase Workflow">
                        <PurchasesPreferences ref={purchasesPreferencesFormRef} />
                    </ContentLayout.Section>
                )}

                {isGranted(Permission.PREFERENCES_ROSTER_VIEW) && (
                    <ContentLayout.Section title="Roster Export">
                        <RosterPreferences ref={rosterPreferencesFormRef} />
                    </ContentLayout.Section>
                )}
            </div>
            <ContentLayout.Footer preferenceSidebar>
                <SubmitButton isLoading={isSubmitting} onClick={handleSubmit}>
                    Save
                </SubmitButton>

                <SecondaryButton onClick={handleReset}>Cancel</SecondaryButton>
            </ContentLayout.Footer>
        </ContentLayout>
    );
};
